import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HolidaysResponse, HolidaysSchool, HolidaysSchoolRequest } from '../models/holidays-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HolidaysService {

  private apiUrl = `${environment.sgcApi}`;
  private holidaysRoute = 'holidays';

  constructor(
    private httpClient: HttpClient
  ) {}

  getHolidaysBySchoolId(schoolId: number, exerciseId: number): Observable<HolidaysSchool> {
    let endpoint = `${this.apiUrl}${this.holidaysRoute}/schoolId/${schoolId}/exerciseId/${exerciseId}`;
    return this.httpClient.get<HolidaysSchool>(endpoint);
  }

  updateHolidays(user: string, exerciseId: number, holidaysSchoolRequest: HolidaysSchoolRequest) {
    let endpoint = `${this.apiUrl}${this.holidaysRoute}/user/${user}/exerciseId/${exerciseId}/update`;
    return this.httpClient.put(endpoint, JSON.stringify(holidaysSchoolRequest));
  }

  createHolidays(user: string, exerciseId: number, holidaysResponse: HolidaysResponse) {
    let endpoint = `${this.apiUrl}${this.holidaysRoute}/user/${user}/exerciseId/${exerciseId}/create`;
    return this.httpClient.post(endpoint, JSON.stringify(holidaysResponse));
  }

  deleteHolidays(user: string, exerciseId: number, holidaysResponse: HolidaysResponse) {
    let endpoint = `${this.apiUrl}${this.holidaysRoute}/user/${user}/exerciseId/${exerciseId}/delete`;
    return this.httpClient.put(endpoint, JSON.stringify(holidaysResponse));
  }
}
